module.exports = __webpack_public_path__ + "static/media/Iran_Zamin.92066da3.svg";